<!-- Revised on 2025/05/12 by mnavarro -->
<template>
  <div v-if="enableSearch" class="d-flex align-items-center ms-md-auto">
    <div class="input-group">
      <span class="input-group-text text-body">
        <i class="fa-solid fa-search" aria-hidden="true"></i>
      </span>
      <input v-model="searchValue" class="form-control ps-2" :placeholder="$t('key_searchbox_placeholder')" type="text" @blur="changeInput" />
      <span v-if="searchValue" class="input-group-text text-body" @click="clearSearch">
        <i class="fa-solid fa-xmark" aria-hidden="true" :title="$t('key_searchbox_clear')"></i>
      </span>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Searchbox",
    props: {
      enableSearch: {
        type: Boolean,
        default: true
      },
      filterSearch: {
        type: String,
        default: ''
      },
    },
    emits: ['search-change'],
    data() {
      return {
        searchValue: this.filterSearch,
      }
    },
    watch: {
      filterSearch(newVal) {
        this.searchValue = newVal || '';
      }
    },
    methods: { 
      changeInput() {
        this.$emit('search-change', this.searchValue);
      },
      clearSearch() {
        this.searchValue = '';
        this.$emit('search-change', "");
      }
    }
  };

</script>